import React from 'react';
import { FormattedMessage } from 'react-intl';
import { discount, code } from '../../utils/promoCode.es';
import styles from './NotificationsPromoCode.scss';

const NotificationsPromoCode = () => {

    return (
        <div className={styles.row}>
            <div className={styles.description}>
                <FormattedMessage
                    id="dbl.NotificationsPromoCode.description"
                    defaultMessage="Exclusive Offer: Save {discount}% on your first purchase"
                    values={{ discount }}
                />
            </div>
            <div className={styles.codeContainer}>
                <FormattedMessage
                    id="dbl.NotificationsPromoCode.codeText"
                    defaultMessage="Code:"
                />
                <span className={styles.code}>
                    {code}
                </span>
                <a href={`/promotions/terms/?promo=${code}`}>
                    <FormattedMessage
                        id="dbl.NotificationsPromoCode.details"
                        defaultMessage="See Details"
                    />
                </a>
            </div>
        </div>
    );
};

export default NotificationsPromoCode;



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationsPromoCode.jsx